import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { isEmptyObject } from 'utilities/common';
import CommonLayout from 'layouts/DashboardLayout';
import { addCategory, getAllCategory, getAllCategoryImages, getCategoryData } from '../../../../redux/slices/hyperwolf/products';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomInput from 'components/common/CustomInput';
import { BASE_URL } from 'utilities/constants';
import { Grid, Button, Typography, Box, Card, TextField } from '@mui/material';
import { slugRegex } from 'utilities/common';
import CommonQuillEditor from 'common/editor';
import { grey } from '@mui/material/colors';


function AddHyperwolfCategory() {
  const dispatch = useDispatch();
  const { categoryImages, singleCategory, loading = false, catData } = useSelector(state => state.hyperwolfProducts);
  const [category, setCategory] = useState({ categoryName: '', description: '' });
  const [selectedImage, setSelectedImage] = useState('');
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");
  const [productSlugData, setProductSlugData] = useState("")
  const [isProductSlug, setIsProductSlugData] = useState(false)

  useEffect(() => {
    if (id) {
      setCategory({
        categoryName: catData?.categoryName || '',
        description: catData?.description || '',
        // webMenuName: catData?.webMenuName || '',
        // heading: catData?.heading || '',
        // metaTitle: catData?.metaTitle || "",
        // metaDescription: catData?.metaDescription || "",
        // bmwCategorySlug: catData?.bmwCategorySlug || ""
      });
      // if (catData?.bmwCategorySlug) {
      //   setProductSlugData(catData?.bmwCategorySlug);
      // }
      setSelectedImage(catData?.image || '');
    }
  }, [id, catData]);

  const handleChangeCategory = (e) => {
    const { name, value } = e.target;
    setCategory({ ...category, [name]: value });
  };

  const addCategoryHandler = () => {
    let updatedData = { ...category };
    // if (isProductSlug) {
    //   updatedData.bmwCategorySlug = productSlugData;
    // } else {
    //   delete updatedData.bmwCategorySlug;
    // }
    // delete updatedData.webCategorySlugArray;
    // delete updatedData.canonical;
    if (selectedImage) {
      updatedData = {
        ...updatedData,
        image: selectedImage
      };
    }
    dispatch(addCategory({ data: updatedData, id: ((id && id) || '') })).then(() => {
      dispatch(getAllCategory());
      navigate('/hyperwolf/manage-categories');
    }).catch(() => { });
  };

  const onClickSelectImage = (url) => {
    setSelectedImage(url);
  };

  useEffect(() => {
    dispatch(getAllCategoryImages());
    // dispatch(getAllCategoryImages());

  }, []);

  useEffect(() => {
    dispatch(getCategoryData(id));
  }, [id])
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegex(value));
  };

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Card sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
          <Typography variant="h4" className="d-flex jc-ctr">{id ? 'Update' : 'Add'} Category</Typography>
          <Grid mt={2} container component="main" className={' add-category-modal-container'}>
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Please Select Image</Typography>
            </Grid>
            <Grid item xs={12} className="add-category-container">
              <div className="add-category-input">
                <div className="category-image-item-2">
                  <div className="select-category-image selected">
                    <img src={BASE_URL.concat(selectedImage)} alt="" />
                  </div>
                </div>
                <div className="category-images-container">
                  <div className="scrollable-sec">
                    {
                      categoryImages?.map((image, indx) => {
                        const isSelected = image.url === selectedImage;
                        return <div key={indx} className="inner-select-image-item">
                          {isSelected ? <div className="tick-placement"><CheckCircleIcon /></div> : null}
                          <div className={`select-category-image ${isSelected ? 'disable-select' : ''}`} onClick={() => onClickSelectImage(image.url)}>
                            <img src={BASE_URL.concat(image.url)} alt="" />
                          </div>
                        </div>;
                      })
                    }
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <CustomInput
                    name="categoryName"
                    value={category.categoryName || ''}
                    onChange={(e) => { handleChangeCategory(e); }}
                    label="Category Name"
                    className="w-100"
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    name="description"
                    value={category.description || ''}
                    onChange={(e) => { handleChangeCategory(e); }}
                    label="Description"
                    className="w-100"
                    margin="normal"
                  />
                </Grid>
                {/* <Grid item xs={12} mt={2} mb={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='Category Menu Name'
                        value={category.webMenuName}
                        fullWidth
                        variant='outlined'
                        onChange={handleChangeCategory}
                        name='webMenuName'
                        className='form-input'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='Category Heading (H1)'
                        value={category.heading}
                        fullWidth
                        variant='outlined'
                        onChange={handleChangeCategory}
                        name='heading'
                        className='form-input'
                      />
                    </Grid>
                    {
                      id && <Grid item xs={12} sm={6}>
                        <TextField
                          className="form-input"
                          fullWidth
                          label="Web Category Slug"
                          name="bmwCategorySlug"
                          value={productSlugData}
                          onChange={handleChangeSlug}
                          disabled={category?.bmwCategorySlug === 'deals' ? true : false}
                        />
                      </Grid>
                    }
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Meta Title*"
                        value={category.metaTitle}
                        fullWidth
                        variant="outlined"
                        onChange={handleChangeCategory}
                        name='metaTitle'
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" fontWeight="medium" color={grey[600]} mb={1}>Meta Description*</Typography>
                  <CommonQuillEditor
                    value={category?.metaDescription || ''}
                    onChange={(value) => setCategory({ ...category, metaDescription: value })}
                  />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid >
          <Box mt={2}>
            <Button 
              disabled={loading} 
              onClick={() => { addCategoryHandler(); }} 
              variant="contained" 
              color="primary"
              style={{ minWidth: "160px" }}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </Box>

    </CommonLayout>
  );
}



export default AddHyperwolfCategory;